module.exports = __webpack_public_path__ + "components/country-flag/static/gi-9f6d1f137b7ceab9c43329ec9fead133.svg";